import React from "react";
import { Dimmer, Loader as SemanticLoader } from "semantic-ui-react";
import PropTypes from "prop-types";

const Loader = ({ active, page, content }) => {
  return (
    <Dimmer active={active} page={page}>
      <SemanticLoader content={content} />
    </Dimmer>
  );
};
Loader.propTypes = {
  active: PropTypes.bool.isRequired,
  page: PropTypes.bool,
  content: PropTypes.string,
};
export default Loader;
